import React from "react";

const Loader = () => {
  return (
    <div>
      <div class="d-flex justify-content-center" style={{
        alignItems:"center",
        top:"50%",
        left:"50%",
        position:"absolute",
        }}>
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  );
};

export default Loader;
